
import React from 'react';
import * as styles from './modalCertif.module.css';

export default function ModalCertif(){
  return (
<div id="modal" className={styles.modal}>
  <img className={styles.modalContent} id="imgmodal" alt="Certificat de formation en taille réelle" />
</div>

  )}

